// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3tBnz{text-align:center}._21ASu{-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg);margin-left:.25rem;width:16px;width:1rem;height:16px;height:1rem}._21ASu path[fill]{fill:#0373f9}._2FxZp{margin-left:.25rem;width:16px;width:1rem;height:16px;height:1rem}._2FxZp path[fill]{fill:#0373f9}._3ImoF{margin:0 auto;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}", ""]);
// Exports
exports.locals = {
	"root": "_3tBnz",
	"chevronIcon": "_21ASu",
	"hintIcon": "_2FxZp",
	"button": "_3ImoF"
};
module.exports = exports;
